import { PropsWithChildren } from "react";
import { classNames } from "../../util/helpers";
import ColumnCell from "./TableColumnCell";
import { useTableContext } from "./TableContext";
import { DataRow } from "./TableDataCell";
import TableLoader from "./TableLoader";
import TableNOResult from "./TableNoResult";
import TableFooter from "./TableFooter";

const TableBody = () => {
    const { data } = useTableContext();

    if (data.length == 0) return <TableNOResult />;

    return <>{data.map((d: any, index: number) => (<DataRow key={index} data={d} />))}</>
}

const TableGrid = () => {
    const { id, caption, columns } = useTableContext();
    return (
        <div className={classNames('ted-ui-table-wrapper')}>
            <div className={classNames('ted-ui-table-wrapper-scroll')}>
                <TableLoader />
                <table id={id}>
                    {caption && <caption className='sr-only'>{caption}</caption>}
                    <thead>
                        <tr>
                            {columns.map((column, index) => <ColumnCell {...column} key={column.accessor + index} />)}
                        </tr>
                    </thead>
                    <tbody>
                        <TableBody />
                    </tbody>
                    <TableFooter />
                </table>
            </div>
        </div>
    )
}

export const TableContainer = ({ children }: PropsWithChildren & { className?: string }) => {

    const { spacing, stripe, border, textAlign, sortOrder, sortBy, firstColumnSticky, lastColumnSticky, loading } = useTableContext();
    // All classes with different features
    const tableType = 'ted-ui-table-type-basic';
    const spacingType = 'ted-ui-table-spacing-' + spacing;
    const stripingType = stripe ? 'ted-ui-table-stripe' : '';
    const borderType = 'ted-ui-table-border-' + border;
    const textAlignType = textAlign ? 'ted-ui-table-text-' + textAlign : '';
    const sortingClass = (sortBy && sortOrder) && `sorting-table-${sortBy}-${sortOrder}`;
    const stickyClass = classNames(
        firstColumnSticky ? 'ted-ui-table-first-col-sticky' : null,
        lastColumnSticky ? 'ted-ui-table-last-col-sticky' : null,
    )
    return (<div data-testid="tableWrap" className={classNames("ted-ui-TableView", "ted-ui-table", tableType, spacingType, stripingType, borderType, textAlignType, sortingClass, stickyClass, loading && "ted-ui-TableLoading")}>
        {children}
    </div>);
}

const TableView = () => {
    return <TableContainer>
        <TableGrid />
    </TableContainer>
}

export default TableView;